// extracted by mini-css-extract-plugin
export default {"toastWrapper":"Toast_toastWrapper__YjLYY","large":"Toast_large__62x45"};